export default __webpack_public_path__ + "static/BitterMedium-5140ed8db3360b8ea9d30646091ddf1d.ttf";